import {
  CandidateAiReviewStateType,
  CandidateCvProcessingType,
  CandidateType,
} from '../candidates/Candidates.types';

const CV_PROCESSING_ACTIVE_STATUSES = ['PROCESSING', 'PENDING', 'RETRY_PENDING'] as const;
const CV_PROCESSING_FAILURE_STATUSES = ['FAILED_RETRYABLE', 'FAILED_NON_RETRYABLE'] as const;

type CandidateAiReviewStateSource = Pick<CandidateType, 'aiSuggestions' | 'cvProcessing'>;

export const getCandidateAiReviewStateFromCandidate = ({
  aiSuggestions,
  cvProcessing,
}: CandidateAiReviewStateSource): CandidateAiReviewStateType => ({
  aiSuggestions,
  cvProcessing,
});

export const isCandidateCvProcessingActive = (status?: string | null) =>
  !!status && CV_PROCESSING_ACTIVE_STATUSES.includes(status as (typeof CV_PROCESSING_ACTIVE_STATUSES)[number]);

export const isCandidateCvProcessingFailure = (status?: string | null) =>
  !!status && CV_PROCESSING_FAILURE_STATUSES.includes(status as (typeof CV_PROCESSING_FAILURE_STATUSES)[number]);

export const isCandidateAiProcessingCutoffBlocked = (cvProcessing?: CandidateCvProcessingType) =>
  cvProcessing?.canProcess === false &&
  cvProcessing.blockedReason === 'candidate-created-before-ai-processing-cutoff';
